import React, { Fragment } from "react";
import { CartProvider } from "react-use-cart";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import App from "./components";
import Home from "./pages/home";
import About from "./pages/about";
import Artikel from "./pages/artikel";
import ArtikelDetail from "./pages/artikel/ArtikelDetail";

import campus_melbourne from "./pages/campus/campus_melbourne";
import campus_ecu from "./pages/campus/campus_ecu";
import campus_tafe from "./pages/campus/campus_tafe";

import country from "./pages/country/index";


import scholarship from "./pages/scholarship";
import studytour from "./pages/studytour";
import contacus from "./pages/contacus";
import Accommodation from "./pages/accommodation";

import singaraja from "./pages/singaraja";
import Career from "./pages/career";
import DetailLowongan from "./pages/career/DetailLowongan";
import Merchandise from "./pages/merchandise";
import Checkout from "./pages/merchandise/Checkout";
import Tracking from "./pages/merchandise/Tracking";
import MerchandiseDetail from "./pages/merchandise/MerchandiseDetail";

const RoutersApp = () => {
  return (
    <CartProvider>
      <BrowserRouter basename={`/`}>
        <Switch>
          <Route
            path={`${process.env.PUBLIC_URL}/singaraja`}
            exact
            component={singaraja}
          />
          <Route
            path={`${process.env.PUBLIC_URL}/merchandise/tracking/:id`}
            exact
            component={Tracking}
          />

          <Fragment>
            <App>
              <Route path="/" exact component={Home} />

              <Route
                path={`${process.env.PUBLIC_URL}/about`}
                exact
                component={About}
              />
              <Route
                path={`${process.env.PUBLIC_URL}/artikel`}
                exact
                component={Artikel}
              />
              <Route
                path={`${process.env.PUBLIC_URL}/artikeldetail/:slug`}
                exact
                component={ArtikelDetail}
              />

              <Route
                path={`${process.env.PUBLIC_URL}/campus/melbourne`}
                exact
                component={campus_melbourne}
              />
              <Route
                path={`${process.env.PUBLIC_URL}/campus/ecu`}
                exact
                component={campus_ecu}
              />
              <Route
                path={`${process.env.PUBLIC_URL}/campus/tafe`}
                exact
                component={campus_tafe}
              />

              <Route
                path={`${process.env.PUBLIC_URL}/country/:code`}
                exact
                component={country}
              />                                                                                                                                    

              <Route
                path={`${process.env.PUBLIC_URL}/scholarship`}
                exact
                component={scholarship}
              />
              <Route
                path={`${process.env.PUBLIC_URL}/study_tour`}
                exact
                component={studytour}
              />
              <Route
                path={`${process.env.PUBLIC_URL}/accommodation`}
                exact
                component={Accommodation}
              />
              <Route
                path={`${process.env.PUBLIC_URL}/career`}
                exact
                component={Career}
              />
              <Route
                path={`${process.env.PUBLIC_URL}/career/:slug`}
                exact
                component={DetailLowongan}
              />
              <Route
                path={`${process.env.PUBLIC_URL}/merchandise`}
                exact
                component={Merchandise}
              />
              <Route
                path={`${process.env.PUBLIC_URL}/merchandise/checkout`}
                exact
                component={Checkout}
              />
              <Route
                path={`${process.env.PUBLIC_URL}/MerchandiseDetail/:code_product`}
                exact
                component={MerchandiseDetail}
              />

              <Route
                path={`${process.env.PUBLIC_URL}/contact_us`}
                exact
                component={contacus}
              />
            </App>
          </Fragment>
        </Switch>
      </BrowserRouter>
    </CartProvider>
  );
};

export default RoutersApp;
